import { render, staticRenderFns } from "./DeleteActions.vue?vue&type=template&id=0780565f&"
import script from "./DeleteActions.vue?vue&type=script&lang=js&"
export * from "./DeleteActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports